import React from "react";
import { Field, Input, Textarea, Select, SectionTitle, Card, ICON_OPTIONS } from "./_shared";
import { X, Plus } from "lucide-react";

export default function SubpageEditor({ value, onChange, accent, title }) {
  const set = (k, v) => onChange({ ...value, [k]: v });

  const setService = (i, patch) => {
    const services = value.services.map((s, idx) => idx === i ? { ...s, ...patch } : s);
    onChange({ ...value, services });
  };
  const addService = () => onChange({ ...value, services: [...value.services, { icon: "sparkles", title: "Nuevo servicio", description: "" }] });
  const removeService = (i) => onChange({ ...value, services: value.services.filter((_, idx) => idx !== i) });

  const setProject = (i, patch) => {
    const projects = value.projects.map((p, idx) => idx === i ? { ...p, ...patch } : p);
    onChange({ ...value, projects });
  };
  const addProject = () => onChange({ ...value, projects: [...value.projects, { title: "Nuevo proyecto", category: "", year: new Date().getFullYear().toString(), image: "" }] });
  const removeProject = (i) => onChange({ ...value, projects: value.projects.filter((_, idx) => idx !== i) });

  return (
    <div>
      <SectionTitle title={title} subtitle="Contenido de la subpágina" />

      <Card className="mb-4">
        <h3 className="font-display text-xl mb-4" style={{ color: accent }}>Hero</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="Eyebrow"><Input value={value.hero_eyebrow} onChange={(e) => set("hero_eyebrow", e.target.value)} /></Field>
          <Field label="Imagen (URL)"><Input value={value.hero_image} onChange={(e) => set("hero_image", e.target.value)} /></Field>
          <div className="md:col-span-2">
            <Field label="Título"><Textarea rows={2} value={value.hero_title} onChange={(e) => set("hero_title", e.target.value)} /></Field>
          </div>
          <div className="md:col-span-2">
            <Field label="Descripción"><Textarea rows={3} value={value.hero_description} onChange={(e) => set("hero_description", e.target.value)} /></Field>
          </div>
        </div>
      </Card>

      <Card className="mb-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-display text-xl" style={{ color: accent }}>Servicios</h3>
          <button onClick={addService} className="inline-flex items-center gap-1 text-xs text-white/60 hover:text-white transition-colors">
            <Plus className="w-3 h-3" /> Añadir
          </button>
        </div>
        <Field label="Título de la sección">
          <Input value={value.services_title} onChange={(e) => set("services_title", e.target.value)} />
        </Field>
        <div className="mt-4 space-y-3">
          {value.services.map((s, i) => (
            <div key={i} className="grid grid-cols-1 md:grid-cols-[140px_1fr_40px] gap-2 p-3 rounded-lg bg-black/40 border border-white/5">
              <Select value={s.icon} onChange={(e) => setService(i, { icon: e.target.value })}>
                {ICON_OPTIONS.map((ic) => <option key={ic} value={ic}>{ic}</option>)}
              </Select>
              <div className="space-y-2">
                <Input value={s.title} onChange={(e) => setService(i, { title: e.target.value })} placeholder="Título" />
                <Textarea rows={2} value={s.description} onChange={(e) => setService(i, { description: e.target.value })} placeholder="Descripción" />
              </div>
              <button onClick={() => removeService(i)} className="w-10 h-10 rounded-lg border border-white/10 hover:border-red-500/40 text-white/50 hover:text-red-400 flex items-center justify-center transition-colors self-start">
                <X className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      </Card>

      <Card className="mb-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-display text-xl" style={{ color: accent }}>Portafolio</h3>
          <button onClick={addProject} className="inline-flex items-center gap-1 text-xs text-white/60 hover:text-white transition-colors">
            <Plus className="w-3 h-3" /> Añadir
          </button>
        </div>
        <Field label="Título de la sección">
          <Input value={value.portfolio_title} onChange={(e) => set("portfolio_title", e.target.value)} />
        </Field>
        <div className="mt-4 space-y-3">
          {value.projects.map((p, i) => (
            <div key={i} className="grid grid-cols-1 md:grid-cols-[1fr_1fr_100px_40px] gap-2 p-3 rounded-lg bg-black/40 border border-white/5">
              <div className="space-y-2">
                <Input value={p.title} onChange={(e) => setProject(i, { title: e.target.value })} placeholder="Título del proyecto" />
                <Input value={p.image} onChange={(e) => setProject(i, { image: e.target.value })} placeholder="URL imagen" />
              </div>
              <Input value={p.category} onChange={(e) => setProject(i, { category: e.target.value })} placeholder="Categoría" />
              <Input value={p.year} onChange={(e) => setProject(i, { year: e.target.value })} placeholder="Año" />
              <button onClick={() => removeProject(i)} className="w-10 h-10 rounded-lg border border-white/10 hover:border-red-500/40 text-white/50 hover:text-red-400 flex items-center justify-center transition-colors self-start">
                <X className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      </Card>

      <Card>
        <h3 className="font-display text-xl mb-4" style={{ color: accent }}>Bloque CTA final</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="Título CTA"><Input value={value.cta_title} onChange={(e) => set("cta_title", e.target.value)} /></Field>
          <Field label="Texto botón"><Input value={value.cta_label} onChange={(e) => set("cta_label", e.target.value)} /></Field>
          <div className="md:col-span-2">
            <Field label="Descripción CTA"><Textarea rows={2} value={value.cta_description} onChange={(e) => set("cta_description", e.target.value)} /></Field>
          </div>
        </div>
      </Card>
    </div>
  );
}
